import React from 'react';
import Hero from '../components/Hero';
import Skills from '../components/Skills';
import WorkExperience from '../components/WorkExperience';
import SEO, { SITE_URL } from '../components/SEO';

const About = () => {
  return (
    <div className="bg-slate-900">
      <SEO
        title="Kajetan Jędrych — Programista / Tworzenie stron internetowych"
        description="Portfolio Kajetana Jędrycha — programisty tworzącego strony internetowe, aplikacje webowe i rozwiązania AI. Zobacz projekty, doświadczenie i bloga technicznego."
        path="/"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Person',
          name: 'Kajetan Jędrych',
          url: SITE_URL,
          jobTitle: 'Software Developer',
          email: 'mailto:jedrychk@gmail.com',
          sameAs: [],
        }}
      />
      <main>
        <Hero />
        <Skills />
        <WorkExperience />
      </main>
    </div>
  );
};

export default About;
